import { useCallback } from "react";
import type { ImageType } from "react-images-uploading";
import { sanitizeFilename } from "utils";
import type { Project } from "../../models";
import { ProjectService } from "../../sections/projects";
import type { UIMessageProps } from "../../services/UI";
import { USER_MSG, getTranslatedUserMsg } from "../../strings";

export const uploadProjectImage = (
  project: Project,
  projId: string,
  showSuccess: (msg?: UIMessageProps) => void,
  showError: (msg?: UIMessageProps) => void,
  t: any,
) => {
  return useCallback(
    async (image: ImageType): Promise<any> => {
      if (image.uploading !== true) {
        image.uploading = true;
        return ProjectService.upload(
          project.id ?? projId,
          sanitizeFilename(image.file!.name),
          image.url,
          image.file?.type,
        ).then(
          (resourceId) => {
            image.id = resourceId;
            image.uploading = false;
          },
          (err) => {
            console.error(err);
            image.uploading = false;
            image.error = true;
            showError(getTranslatedUserMsg(t, "ERROR_IMAGE"));
          },
        );
      }
    },
    [project.id, projId, showSuccess, showError],
  );
};
